module.exports = __webpack_public_path__ + "assets/img/wechatshop.e91c8774.png";